"use client";

import { usePathname } from "next/navigation";
import { useMemo } from "react";

export function usePageType(): string {
	const pathname = usePathname() || "/";

	return useMemo(() => {
		if (pathname.includes("/news")) return "NEWS_PAGE";
		if (pathname.includes("/series")) return "SERIES_PAGE";
		if (pathname.includes("/movie")) return "MOVIES_PAGE";
		if (pathname.includes("/games")) return "GAME_PAGE";
		if (pathname.includes("/board-games")) return "BOARD_GAME_PAGE";
		if (pathname === "/" || pathname === "") {
			return "MAIN_PAGE";
		}

		return "ANOTHER_PAGE";
	}, [pathname]);
}
